module.exports = __webpack_public_path__ + "static/media/layout-sel.3fb838dc.svg";